import { ViteReactSSG } from 'vite-react-ssg';
import routes from './routes';

/**
 * vite-react-ssg entry.
 *
 * The plugin pre-renders every route at build time into static HTML that
 * then hydrates on the client. This is what makes our Vite SPA viable for
 * SEO / GEO (generative-engine optimisation) without switching frameworks.
 */
export const createRoot = ViteReactSSG({ routes });
